import Vue from "vue";
import Router from "vue-router";
import Home from "../page/Home/Home.vue";
import QnrFinish from "../page/QnrFinish/QnrFinish.vue";
import Ref from "../page/QnrFinish/Ref.vue";


Vue.use(Router);
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  if(originalPush.call(this, location)!=undefined){
    return originalPush.call(this, location).catch(err => err)
  }
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace (location) {
  if(originalReplace.call(this, location)!=undefined){
    return originalReplace.call(this, location).catch(err => err)
  }
}
export default new Router({
  mode:'history',
  routes: [
    {
      path: "/home",
      name: "Home",
      component: Home
    },
    {
      path: "/qnrFinish",
      name: "QnrFinish",
      component: QnrFinish
    },
    {
      path: "/ref",
      name: "Ref",
      component: Ref
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js